(function () {
  const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    const images = imagesWrapper.querySelectorAll('.js-image-zoom');

    images.forEach(el => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    })
  };

  const initProductMediaBack = (root = document) => {
    const allowedDomain = 'monsieur-paris.com';
    let referrerHost = '';

    try {
      referrerHost = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : '';
    } catch (error) {
      referrerHost = '';
    }

    const hasAllowedReferrer =
      referrerHost === allowedDomain || referrerHost.endsWith(`.${allowedDomain}`);

    root.querySelectorAll('[data-product-media-back]').forEach((button) => {
      if (!hasAllowedReferrer) return;

      button.hidden = false;

      if (button.dataset.productMediaBackInitialized === 'true') return;
      button.dataset.productMediaBackInitialized = 'true';

      button.addEventListener('click', () => {
        const currentReferrerHost = document.referrer
          ? new URL(document.referrer).hostname.toLowerCase()
          : '';

        if (
          currentReferrerHost === allowedDomain ||
          currentReferrerHost.endsWith(`.${allowedDomain}`)
        ) {
          window.history.back();
        }
      });
    });
  };

  document.addEventListener('shopify:section:load', function (event) {
    initProductAccordion();
    initZoomImage();
    initProductMediaBack(event.target);
  });

  initProductAccordion();
  initZoomImage();
  initProductMediaBack();
})();
